import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { Observable } from "rxjs";

type Entity = models.EntregaIngresosAUsuario;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    onGuardar: () => Promise<void>;
    nuevo: boolean;
}

/**
* Componente para editar un Entity
*/
export class EntregaIngresoAUsuarioFormNoRx extends React.PureComponent<Props> {
    errors = () => validation.getErrors(this.rules, this.props.value);
    getField = formfields(() => this.props, this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            IdUsuarioZE: validation.required,
            Monto: validation.required
        };
    }

    idUsuario = (x: Props) => x.value.IdUsuarioZE;

    saldo = createSelectorRx(this.idUsuario, idUsuario => idUsuario ? observeResource(resources.SaldosUsuariosZE.ObtenerSaldoUsuario, idUsuario) : toObservable(0));

    UsuarioClabe = createSelectorRx(this.idUsuario, idUsuario => 
        idUsuario ?
        observeResource(resources.UsuarioZE.GetClabe, idUsuario) : observeResource(resources.UsuarioZE.GetClabe, 0))

    UsuarioFormaPago = createSelectorRx(this.idUsuario, idUsuario => 
        idUsuario ?
        observeResource(resources.UsuarioZE.GetFormaPago, idUsuario) : observeResource(resources.UsuarioZE.GetFormaPago, 0));

    render() {
        const { value, nuevo, onGuardar } = this.props;
        const getField = this.getField;

        const UsuarioZE = getField(selectores.UsuarioZE);
        const FormaPago = getField(selectores.ClaveFormaPagoSat);
        const Number = getField(kea.Number);
        const Text = getField(kea.Text);
        const saldo = this.saldo(this.props);

        const usuarioClabe = this.UsuarioClabe(this.props);
        const UsuarioFormaPago = this.UsuarioFormaPago(this.props);
        return (
            <div>
                <kea.Title titulo="Entrega ingresos a proveedor ZE" onRegresar={() => history.go("../")} />
                {kea.autogrid(6, [
                    <kea.Number value={saldo} format="currency" label="Saldo de usuario de zona extendida" readonly />
                ])}

                {kea.autogrid(6, [
                    <Number field="Monto" label="Monto:" format="currency" />,
                    <UsuarioZE field="IdUsuarioZE" label="Proveedor ZE:" />,
                    <Text field="CuentaBancaria" value={ usuarioClabe} label="Cuenta Bancaria" />
                    ,<Text field="Factura" label="Factura" />
                    ,<FormaPago value={UsuarioFormaPago} field="IdFormaPagoSAT" label="Forma de pago" />
                ])}

                <div className="row">
                    <div className="col-md-12">
                        <kea.GuardarButton onClick={onGuardar} disabled={validation.hasError(this.errors())} />
                    </div>
                </div>
            </div>);
    }
}

export const EntregaIngresosAUsuarioForm = componentToRx(EntregaIngresoAUsuarioFormNoRx);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/entregaingresoZE/edit/form.tsx